import request from '@/utils/request';
import { datasetEndpoint, endpoints } from '@/constants/urls';

const datasourceFeatures = (code) => request({
  method: 'GET',
  url: `${datasetEndpoint(code)}/datasource/features`,
});

const datasourceSettings = (code) => request({
  method: 'GET',
  url: `${datasetEndpoint(code)}/datasource/settings`,
});

const datasourceTypes = (enabled) => request({
  url: endpoints.DATASOURCE_TYPES,
  method: 'GET',
  params: {
    enabled,
  },
});

const updateDatasetDatasource = ({
  code,
  host,
  name,
  password,
  port,
  type,
  username,
}) => request({
  method: 'PUT',
  url: `${datasetEndpoint(code)}/datasource/settings`,
  data: {
    host,
    name,
    password,
    port,
    type,
    username,
  },
});

const testDatsetDatasource = ({
  code,
  host,
  name,
  password,
  port,
  type,
  username,
}) => request({
  method: 'POST',
  url: `${datasetEndpoint(code)}/datasource/test`,
  data: {
    host,
    name,
    password,
    port,
    type,
    username,
  },
});

const testDatasource = ({
  host,
  name,
  password,
  port,
  type,
  username,
}) => request({
  method: 'POST',
  url: `${endpoints.DATASOURCES}test`,
  data: {
    host,
    name,
    password,
    port,
    type,
    username,
  },
});

const DatasourceService = {
  datasourceFeatures,
  datasourceSettings,
  datasourceTypes,
  updateDatasetDatasource,
  testDatsetDatasource,
  testDatasource,
};

export default DatasourceService;
